export const collectionsMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

const currentYear = new Date().getFullYear()
export const collectionsYears = Array.from({ length: 5 }, (_, index) => currentYear - index)

export const payOrQuitPostingStates = [
  { value: 'AL', label: 'Alabama' },
  { value: 'GA', label: 'Georgia' },
  { value: 'IN', label: 'Indiana' },
  { value: 'MO', label: 'Missouri' },
  { value: 'NC', label: 'North Carolina' }
]

export const payOrQuitPostingStateForAddress = (state: string) => {
  const normalizedState = state.trim().toLowerCase()
  return payOrQuitPostingStates.find(
    ({ value, label }) =>
      value.toLowerCase() === normalizedState || label.toLowerCase() === normalizedState
  )?.value
}

export type PayOrQuitPostingSelection = { state: string; month: number; year: number }

export const payOrQuitPostingSelection = (search: string): PayOrQuitPostingSelection => {
  const params = new URLSearchParams(search)
  const month = Number(params.get('month'))
  const year = Number(params.get('year'))
  return {
    state: payOrQuitPostingStateForAddress(params.get('state') ?? '') ?? 'GA',
    month: Number.isInteger(month) && month >= 1 && month <= 12 ? month : new Date().getMonth() + 1,
    year: collectionsYears.includes(year) ? year : currentYear
  }
}

export const payOrQuitPostingHref = ({ state, month, year }: PayOrQuitPostingSelection) =>
  `/collections/pay-or-quit-posting?${new URLSearchParams({
    state,
    month: String(month),
    year: String(year)
  })}`
